// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import onePageCheckoutPageLayoutSharedStyles from "@bg/App/SharedStyles/OnePageCheckout/OnePageCheckoutPageLayoutSharedStyles";
import { containerStyles } from "@bg/Overrides/Widgets/OnePageCheckout/OnePageCheckoutPageContainer";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { color } from "@bg/XDL/Utilities";
import { mergeWithCss } from "@bg/XDL/Utilities/mergeWithCss";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

containerStyles.wrapper = {
    ...onePageCheckoutPageLayoutSharedStyles.wrapper,
};

containerStyles.container = {
    ...onePageCheckoutPageLayoutSharedStyles.container,
};

containerStyles.backToCartLink = {
    typographyProps: {
        lineHeight: fontConfig.lineHeight.regular,
    },
    css: css`
        margin-top: 12px;
        margin-bottom: 20px;
    `,
};

containerStyles.title = {
    ...onePageCheckoutPageLayoutSharedStyles.title,
};

containerStyles.leftSection = {
    ...onePageCheckoutPageLayoutSharedStyles.leftSection,
};

containerStyles.rightSection = {
    ...onePageCheckoutPageLayoutSharedStyles.rightSection,
};
containerStyles.detailsContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.addressesContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.paymentContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.shippingContainer = {
    ...onePageCheckoutPageLayoutSharedStyles.infoSection,
};

containerStyles.productsContainer = {
    ...mergeWithCss(onePageCheckoutPageLayoutSharedStyles.productsContainer, {
        css: css`
            ${xScreen("lte", 1200)} {
                display: none;
            }
        `,
    }),
};

containerStyles.productsContainerTablet = {
    ...mergeWithCss(onePageCheckoutPageLayoutSharedStyles.productsContainer, {
        css: css`
            display: none;
            ${xScreen("lte", 1200)} {
                display: block;
                grid-column: 1/3;
            }
            ${xScreen("lte", "xs")} {
                grid-column: initial;
            }
        `,
    }),
};

containerStyles.stickyHeaderWrapper = {
    css: css`
        position: fixed;
        left: 0;
        background: ${color("common.white")};
        width: 100%;
        z-index: ${getProp("theme.zIndex.stickyFooter")};
        transition: all 300ms ease-out;
        box-shadow: 0 -1px 0 0 ${color("common.ui3")};
        opacity: 1;
        max-height: fit-content;
        height: fit-content;
        overflow: hidden;

        &.stickyVisible {
            bottom: 0;
        }

        &.stickyHidden {
            bottom: -200px;
        }

        ${xScreen("gt", "md")} {
            display: none;
        }
    `,
};
